import { StorageCountSessionStatus, StorageCountVerdict } from '@navio/nsdk';
import type { NoddiIconName } from 'noddi-ui-common';

export const STORAGE_COUNT_SESSION_STATUS_ICON: Record<StorageCountSessionStatus, NoddiIconName> = {
  [StorageCountSessionStatus.ACTIVE]: 'ScanLine',
  [StorageCountSessionStatus.COMPLETED]: 'CircleCheck',
  [StorageCountSessionStatus.CANCELLED]: 'CircleX'
};

export const STORAGE_COUNT_VERDICT_ICON: Record<StorageCountVerdict, NoddiIconName> = {
  [StorageCountVerdict.MATCH]: 'CircleCheck',
  [StorageCountVerdict.WRONG_UNIT]: 'ArrowLeftRight',
  [StorageCountVerdict.MISSING]: 'TriangleAlert',
  [StorageCountVerdict.UNEXPECTED]: 'CircleHelp',
  [StorageCountVerdict.MOVED_OUT]: 'Truck'
};
